module.exports = __webpack_public_path__ + "static/subscribe-9f52dae0f9a3e101f1866a5d90a0c6b5.png";